import React, { Component } from 'react';
import '../scss/App.scss';

import Header from './lib/Header';
import Footer from './lib/Footer';

import Home from './routes/Home';
import DistrictDetail from './routes/DistrictDetail';
import RaceDetail from './routes/RaceDetail';
import RacesToWatch from './routes/RacesToWatch';

import utils from '../../utils';

const RACES_TO_WATCH = [
  'd1',
  'd2',
  'd4',
  'd6',
  'd8',
  'd9',
  'd13',
  'd14',
  'd18',
  'd20',
  'd21',
  'd28',
  'd35',
  'd38',
  'd40',
  'd41',
  'd43',
  'd49'
];

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {route: 'index'};
    this.utils = utils({});
  }
  
  routeTo(data = {}) {
    window.scrollTo(0, 0);
    this.utils.pym.scrollParentToChildPos(-100);
    this.setState({ ...data });
  }
  
  render() {
    let { districts, races } = this.props;
    let page;
    switch(this.state.route) {
    case 'index':
      page = <Home
              districts={districts}
              party={this.state.party}
              address={this.state.address}
              route={this.routeTo.bind(this)}/>;
      break;
    case 'district':
      page = <DistrictDetail
              races={races}
              district={this.state.district}
              party={this.state.party}
              route={this.routeTo.bind(this)}
              isBronx={this.state.isBronx}
              isBrooklyn={this.state.isBrooklyn} />;
      break;
    case 'race':
      page = <RaceDetail
              race={this.state.race}
              raceLabel={this.state.raceLabel}
              route={this.routeTo.bind(this)}
              party={this.state.party}
              district={this.state.district} />;
      break;
    case 'watch':
      let racesToWatch = {
        Mayor: races.mayor.candidates,
        'Brooklyn DA': races.da.candidates
      };
      RACES_TO_WATCH.forEach(k => racesToWatch[k] = races[k].candidates);
      page = <RacesToWatch
              races={racesToWatch}
              route={this.routeTo.bind(this)} />;
      break;
    }
    return (
      <div className="App">
        <Header />
        {page}
        <Footer />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./app/src/js/App.js